(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-sound-toggle]');
    if (!toggle) return;

    const card = toggle.closest('.video-card');
    const video = card && card.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    toggle.setAttribute('aria-pressed', String(!video.muted));

    if (!video.muted) {
      video.play().catch(() => {
        /* Autoplay with sound can be blocked; the muted state is already updated. */
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
